export default __webpack_public_path__ + "static/media/aliado-blockchain.931fb781.png";